import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialMediumSvg } from "./IconSocialMediumSvg.mjs";
const IconSocialMedium = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialMediumSvg, ...svgProps }) });
export {
  IconSocialMedium
};
